import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './navbar.css'

import { connect } from 'react-redux'
import { setLogin, setUser } from '../../redux/login/actions'
import { port } from '../../service/index'
import { withRouter } from 'react-router-dom'

class Navbar extends Component {

    constructor(props) {
        super(props)

        this.state = {
            avatar: null
        }
    }


    componentDidMount = async () => {

        const { user_id, token } = this.props.login.user

        fetch(port + '/image/' + user_id + '.png', {
            method: 'GET',
            headers: {
                Authorization: token
            }
        }).then(res => res.blob())
            .then(content => {
                const urlCreator = window.URL || window.webkitURL

                const avatar = urlCreator.createObjectURL(content)
                this.setState({
                    avatar: avatar
                })
            })

    }

    render() {
        const { user_id, name, lastname, department, role } = this.props.login.user
        const { avatar } = this.state
        const fullname = `คุณ ${name} ${lastname}`
        return (
            <nav className='navbar'>
                <div className='container'>
                    <div className='navbar-brand' >
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                            <Link className='navbar-item' to='/' ><img src={require('../../assets/image/logo_home.png')} alt='logo' width={60} /></Link>
                            <p style={{ fontSize: 20, }} > ({role}) </p>
                        </div>
                    </div>
                    <div className='navbar-menu' >
                        <div className='navbar-end' >
                            <Profile src={avatar} name={fullname} onLogout={this._logout} />
                        </div>
                    </div>
                </div>
            </nav>
        )
    }

    _logout = () => {
        this.props.setUser({})
        this.props.setLogin(false)
        this.props.history.push('/login')
    }

}


const Profile = ({ src, name, onLogout }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }} >
            <figure className='image is-32x32' style={{ marginRight: 16 }} >
                <img src={src ? src : "https://cdn3.iconfinder.com/data/icons/avatars-15/64/_Ninja-2-256.png"} alt='avatar' className='avatar' />
            </figure>
            <p>{name ? name : "คุณ ไข่เจียว ทองหยอด"}</p>
            <DropDWN onLogout={onLogout} />
        </div>
    )
}

class DropDWN extends Component {

    constructor(props) {
        super(props)

        this.state = {
            dropdownToggle: false,
            wrapperDropdown: null,
            wrapperLogout: null,
            wrapperChangeProfile: null,
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClose);
        document.addEventListener("mousedown", this.handleLogout);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClose);
        document.removeEventListener("mousedown", this.handleLogout);
    }

    render() {
        const { dropdownToggle } = this.state

        return (
            <div className='dropdown is-right'>
                <div className="dropdown-trigger">
                    <button className='dropdown-btn' ref={this.setWarpDropdown} onClick={() => this.setState(prevState => ({ dropdownToggle: !prevState.dropdownToggle }))} >
                        <img
                            className="dropdown-blue"
                            src={require("../../assets/icon/dropdown_arrow_write.png")}
                            alt="dropdown"
                        />
                    </button>
                    <div
                        className={dropdownToggle ? "dropdown-menu active-dropdown" : 'dropdown-menu'}
                        id="dropdown-menu"
                        role="menu"
                    >
                        <div className="dropdown-content" id='dropdown-header'>
                            <a ref={this.setWarpLogout} className="dropdown-item"  >
                                ออกจากระบบ
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    handleClose = (event) => {

        if (this.state.wrapperDropdown && !this.state.wrapperDropdown.contains(event.target)) {
            this.setState({ dropdownToggle: false })
        }

    }

    setWarpDropdown = (node) => {
        this.setState({ wrapperDropdown: node })
    }

    setWarpLogout = node => {
        this.setState({ wrapperLogout: node })
    }

    setWarpChangeProfile = node => {
        this.setState({ wrapperChangeProfile: node })
    }

    handleLogout = (event) => {
        if (this.state.wrapperLogout && this.state.wrapperLogout.contains(event.target)) {
            this.props.onLogout()
        }

    }
}

const mapStateToProps = state => ({
    login: state.login
})

const mapDispatchToProps = dispatch => ({
    setLogin: payload => dispatch(setLogin(payload)),
    setUser: payload => dispatch(setUser(payload))
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar))




// WEBPACK FOOTER //
// ./src/components/navbar/navbar.js